
class CircleCalculations {
  /**
   * Constructor
   *
   * @return  {void}
   */
  constructor () {
    this.circleDimensions = [0, 0]
  }

  /**
   * setCircleDimensions
   *
   * @param   {integer}  height  The height of the circle
   * @param   {integer}  width   The width of the circle
   *
   * @return  {void}
   */
  setCircleDimensions (width, height) {
    this.circleDimensions = [width, height]
  }

  /**
   * Returns the main circle information
   *
   * @return  {object} An object with dimensions, x and y position
   */
  getSubAttributeCircleInformation () {
    let lw = this.circleDimensions[0] / 6 - 2
    let d = this.circleDimensions[0] / 2
    let r = d / 2
    let l = 2 * Math.PI * r

    return {
      x: d / 2,
      y: d / 2,
      d: d,
      r: r,
      l: l,
      linewidth: lw
    }
  }

  /**
   * Returns the main circle information
   *
   * @return  {object} An object with dimensions, x and y position
   */
  getAttributeCircleInformation () {
    let lw = this.circleDimensions[0] / 6
    let d = this.circleDimensions[0] - lw
    let r = d / 2
    let l = 2 * Math.PI * r

    return {
      x: lw / 2,
      y: lw / 2,
      d: d,
      r: r,
      l: l,
      linewidth: lw
    }
  }

  /**
   * The the circle line info
   *
   * @return  {object}
   */
  getCircleLineInfo (degree, position) {
    let x = this.circleDimensions[0] / 2
    let y = this.circleDimensions[1] / 2
    let r = position !== 1 ? this.circleDimensions[0] / 2 : this.circleDimensions[0] / 4
    let a = degree * Math.PI / 180
    let lx = x + r * Math.cos(a)
    let ly = y + r * Math.sin(a)

    return {
      x: x,
      y: y,
      lx: lx,
      ly: ly
    }
  }

  /**
   * Return the center circle X and y
   *
   * @return  {object} An object with dimensions, x and y position
   */
  getCenterCircleXY () {
    let d = this.circleDimensions[0] / 3
    let x = this.circleDimensions[0] / 2 - (d / 2)
    let y = this.circleDimensions[1] / 2 - (d / 2)

    return { d: d, x: x, y: y }
  }

  /**
   * Return the X and Y position for an attribute slice
   * based on
   *
   * @return  {object} An object with the XY positions
   */
  getAttributeXY (degree, position) {
    let x = this.circleDimensions[0] / 2
    let y = this.circleDimensions[1] / 2
    let r = position !== 1 ? this.circleDimensions[0] / 2 : this.circleDimensions[0] / 4
    let a = degree * Math.PI / 180
    let lx = x + r * Math.cos(a)
    let ly = y + r * Math.sin(a)

    return { x: lx, y: ly }
  }

  getLabelInfo (degree, position) {
    let x = this.circleDimensions[0] / 2
    let y = this.circleDimensions[1] / 2
    let r = position !== 1 ? this.circleDimensions[0] / 2.4 : this.circleDimensions[0] / 4.2
    let rotation = position === 1 ? degree + 90 : degree
    let a = degree * Math.PI / 180
    let lx = x + r * Math.cos(a)
    let ly = y + r * Math.sin(a)

    if (rotation > 90 && rotation < 270) {
      rotation = rotation - 180
    }

    return { x: lx, y: ly, rotation: rotation }
  }
}

export default CircleCalculations



// WEBPACK FOOTER //
// ./src/components/shared/charts/CircleCalculations.js